// 本地名人头像。生产资源必须由本站静态目录或自有 OSS 提供。
// 文件约定：public/celebrity-avatars/{name}.jpg。

export interface CelebrityAvatar {
  url: string;
  source: "local";
}

// 有本地头像文件的名人白名单（与 public/celebrity-avatars/ 目录同步）
const AVATAR_NAMES = new Set([
  "Angelababy", "C罗", "Jennie", "Lisa", "丁程鑫", "丞磊", "井柏然", "亚马尔",
  "任贤齐", "何炅", "关晓彤", "内马尔", "刘亦菲", "刘宇宁", "刘德华",
  "刘昊然", "刘涛", "刘烨", "刘诗诗", "华晨宇", "古天乐", "向佐",
  "吴建豪", "吴彦祖", "吴昕", "吴磊", "周冬雨", "周星驰", "周杰伦",
  "周润发", "周深", "周渝民", "周笔畅", "周迅", "哈兰德", "哈登",
  "唐嫣", "基德", "姆巴佩", "姚晨", "姜文", "孙俪", "孙杨", "孙燕姿",
  "孙红雷", "孙颖莎", "宋佳", "宋茜", "容祖儿", "尚雯婕", "应采儿",
  "张凌赫", "张学友", "张惠妹", "张新成", "张智霖", "张曼玉", "张杰",
  "张碧晨", "张继科", "张艺兴", "张艺谋", "张艾嘉", "张译", "张靓颖",
  "张韶涵", "彭昱畅", "徐嘉余", "徐峥", "徐静蕾", "成毅", "成龙",
  "戚薇", "易烊千玺", "朱一龙", "朱孝天", "李一桐", "李克勤", "李冰冰",
  "李宇春", "李易峰", "李现", "李荣浩", "杜海涛", "杨丞琳", "杨幂",
  "杨洋", "杨紫", "林俊杰", "林志炫", "林青霞", "梁朝伟", "梁静茹",
  "梅西", "樊振东", "殷桃", "汤唯", "汪苏泷", "沙溢", "海清", "潘玮柏",
  "王一博", "王俊凯", "王力宏", "王宝强", "王心凌", "王志文", "王楚钦",
  "王源", "王祖蓝", "王菲", "王鹤棣", "田曦薇", "白敬亭", "秦海璐",
  "程潇", "章子怡", "罗云熙", "罗志祥", "罗斯", "肖战", "胡彦斌",
  "胡歌", "舒淇", "艾弗森", "苏醒", "范冰冰", "莫文蔚", "萧亚轩",
  "萧敬腾", "董卿", "董洁", "蔡依林", "蔡少芬", "蔡徐坤", "薛之谦",
  "虞书欣", "袁咏仪", "袁泉", "言承旭", "许嵩", "谢娜", "赵丽颖",
  "赵文卓", "赵薇", "赵露思", "迪丽热巴", "邓紫棋", "邓超", "那英",
  "郑钦文", "郭富城", "金晨", "陈凯歌", "陈哲远", "陈坤", "陈奕迅",
  "陈小春", "陈慧琳", "陈数", "陈道明", "霍建华", "霍思燕", "韩寒",
  "马云", "高圆圆", "魏晨", "鹿晗", "黄子韬", "黄晓明", "黄龄",
  "Jennie", "孙兴慜", "白鹿", "詹姆斯", "鞠婧祎",
  "檀健次", "宋亚轩", "郑恺", "徐志胜", "吴倩", "张若昀", "杨坤",
  "王安宇", "齐思钧", "周柯宇", "刘强东", "张月", "张远",
  "单依纯", "赵今麦", "李沁", "龚俊", "陈瑶", "范丞丞", "侯明昊", "李晨",
  "丁禹兮", "全红婵", "冯小刚", "刘雨昕", "卢昱晓", "吴京", "姚明",
  "孟子义", "宋祖儿", "库里", "张雨霏", "敖瑞鹏", "景甜", "李维嘉",
  "杨超越", "欧阳娜娜", "沈腾", "章若楠", "罗永浩", "谷爱凌", "辛芷蕾",
  "闫妮", "陈都灵", "雷军", "马思纯", "马龙", "魏大勋",
  "时代少年团", "唐艺", "严浩翔",
  "周翊然", "孙怡", "张子枫", "张怡宁", "撒贝宁", "贺峻霖",
]);

export function getCelebrityAvatar(name: string): CelebrityAvatar | null {
  const normalizedName = name.trim();
  if (!normalizedName || !AVATAR_NAMES.has(normalizedName)) return null;

  return {
    url: `/celebrity-avatars/${encodeURIComponent(normalizedName)}.jpg`,
    source: "local",
  };
}
